import React from 'react';
import InternalImage from '../internal-image-v2';
function getUrl(url) {
    if (!url.match(/^[a-zA-Z]+:\/\//)) {
        url = 'http://' + url;
    }
    return url;
}
export default function PartnerDisplay(props) {
    const {partner} = props;
    if(!partner.image){
        return null;
    }
    return (
        <div className="partner">
            {partner.link
                ? <a href={getUrl(partner.link)} target="_blank">
                        <InternalImage filename={partner.image.filename} alt={partner.name}/>
                    </a>
                : <InternalImage filename={partner.image.filename} alt={partner.name}/>}

        </div>
    )
}



// WEBPACK FOOTER //
// ./src/js/components/partner/partner-display.js